// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"241309f1","453":"15d29c12"}[chunkId] + ".chunk.css";
};